import React, { useCallback, useEffect, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { menuSectionStore } from '../../../store/menuSectionStore';
import { userSettingsStore } from '../../../store/userSettingsStore';
import { soundService } from '../../../services/soundService';
import { isMobile } from '../../../core/helpers/isMobile';
import GameSettings from '../../../components/web/webGameSettings';
import { userInfoStore } from '../../../store/userInfoStore';

const GameSettingsWrapper = observer(() => {
  const { isSoundOn, setIsSoundOn, isFullScreen } = userSettingsStore;
  const { isShowMenuPopup, setIsShowMenuPopup } = menuSectionStore;
  const { isReplay } = userInfoStore;

  const handleClickSoundIcon = useCallback(() => {
    setIsSoundOn(!isSoundOn);
    if (isSoundOn) {
      soundService.stopAll();
    } else {
      soundService.playMusic();
    }
  }, [isSoundOn, setIsSoundOn]);

  const handleClickBurgerIcon = useCallback(() => {
    setIsShowMenuPopup(!isShowMenuPopup);
  }, [isShowMenuPopup, setIsShowMenuPopup]);

  const handleClickFullScreen = useCallback(() => {
    window.parent.postMessage({ name: 'pgToggleFullscreen' }, '*');
  }, []);

  const handleKeyDown = useCallback((e) => {
    if (e.code === 'F11') {
      e.preventDefault();
      window.parent.postMessage({ name: 'pgToggleFullscreen' }, '*');
    }
  }, []);

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleKeyDown]);

  const {
    containerConfig,
    menuIconsBackgroundConfigs,
    fullScreenIconConfig,
    burgerIconConfig,
    soundIconConfig,
  } = useMemo(() => {
    return {
      containerConfig: {
        y: isMobile() ? 20 : 48,
      },
      menuIconsBackgroundConfigs: {
        x: isMobile() ? 262 : 173,
      },
      burgerIconConfig: {
        x: isMobile() ? 499 : 23,
        click: handleClickBurgerIcon,
        touchend: handleClickBurgerIcon,
      },
      fullScreenIconConfig: {
        x: 57,
        click: handleClickFullScreen,
        touchend: handleClickFullScreen,
        isShow: !isMobile(),
        interactive: !isReplay,
      },
      soundIconConfig: {
        x: isMobile() ? 457 : 90,
        click: handleClickSoundIcon,
        touchend: handleClickSoundIcon,
      },
    };
  }, [handleClickBurgerIcon, handleClickFullScreen, handleClickSoundIcon]);

  return (
    <GameSettings
      burgerIconConfig={burgerIconConfig}
      fullScreenIconConfig={fullScreenIconConfig}
      soundIconConfig={soundIconConfig}
      containerConfigs={containerConfig}
      menuIconsBackgroundConfigs={menuIconsBackgroundConfigs}
      isSoundOn={isSoundOn}
      isFullScreen={isFullScreen}
    />
  );
});
export default GameSettingsWrapper;
